<template>
    <div class="vx-card p-4">
        <div class="vx-row mt-2">
            <!-- Label & Input-->
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label">{{ $t('wifi.branch') }}</label>
                <v-select
                    class="w-full"
                    v-model="selectedBranch"
                    :options="branchOptions"
                    name="branch"
                    v-validate="'required'">
                    <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <!-- Button -->
            <div class="vx-col md:w-3/4 w-full">
                <div class="mt-6 flex flex-wrap float-right">
                    <!--                    <vs-button-->
                    <!--                        class="mt-2 mr-2"-->
                    <!--                        color="primary"-->
                    <!--                        iconPack="feather"-->
                    <!--                        icon="icon-package">-->
                    <!--                        Thêm dịch vụ cho phòng ban-->
                    <!--                    </vs-button>-->
                    <vs-button
                        color="primary"
                        class="mt-2"
                        @click="addDepartment"
                        iconPack="feather"
                        icon="icon-plus">
                        {{ $t('button.addDepartments') }}
                    </vs-button>
                </div>
            </div>
        </div>
        <!--Table-->
        <div class="vx-row mt-2">
            <div class="vx-col w-full">
                <ag-grid-vue
                    style="height: 55vh"
                    ref="agGridTable"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="departmentData"
                    :animateRows="true"
                    :localeText="{noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                    @pagination-changed="onPaginationChanged"
                    @grid-ready="onGridReady"
                    :autoSizeStrategy="autoSizeStrategy">
                </ag-grid-vue>

                <!-- Pagination Bottom-->
                <div class="vx-row mt-8" v-if="totalElements > 0">
                    <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                        <span class="content-page font-bold">Hiển thị: </span>
                        <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-pagination
                            :total="totalPages"
                            v-model="currentPage"
                            @change="loadPage"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    name: 'Department',
    components: {
        vSelect,
        AgGridVue,
        CellRendererActions
    },
    data() {
        return {
            searchQuery: "",
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 100,
                },
                {
                    headerName: 'Tên phòng ban',
                    field: 'departmentName',
                    width: 200,
                },
                {
                    headerName: 'Chi nhánh',
                    field: 'organizationBranchName',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                }
            ],
            branchOptions: [],
            selectedBranchValue: null,
            departmentData: null,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(x => x.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'})
        this.getDepartment();
    },
    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label,
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getDepartment()
            }
        }
        //End v-select
    },
    watch: {
        '$store.state.isDeleteDepartment'(val) {
            if (val) {
                this.getDepartment();
                this.$store.commit('DELETE_DEPARTMENT', false);
            }
        },
    },
    methods: {
        getDepartment() {
            let body = {
                organizationBranchId: this.selectedBranchValue
            }
            this.$vs.loading();
            this.$crm.post('/department/find-by-condition', body).then(res => {
                this.departmentData = res.data.map(el => {
                    el.stt = res.data.indexOf(el) + 1;
                    let result = this.branchOptions.find(x => x.value == el.organizationBranchId)
                    if (result) {
                        el.organizationBranchName = result.label
                    }
                    return el;
                });
                this.countElementPage = this.currentPage * 10;
                this.totalElements = this.departmentData.length;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title:'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon:'icon-alert-circle',
                    color:'danger'
                })
            })
        },
        addDepartment() {
            this.$router.push('/user/department-info')
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
